import { Button, ButtonGroup, ConfirmDialog, Field } from 'Components/Core';
import withInjectedProps from 'Components/Core/InjectedPropsContext/withInjectedProps';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { isNil } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { OversizeMaterialRemovedBy, PreparationMethod } from '../../types';
let AsPreparationSieveSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
  prefixName,
  addArrayEntry,
  removeArrayEntry,
}) => {
  const oversizeMaterialRemovedBy = useSelector(pipe(createWorksheetSelector!(`PreparationProcessingMethod`)));
  const PreparationMethodValue = useSelector(pipe(createWorksheetSelector!(`PreparationMethod`)));
  const guardSieveSize = useSelector(createWorksheetSelector!(`GuardSieveSize`), deepEquals);
  const oversizeSieveSize = useSelector(createWorksheetSelector!(`OversizeSieveSize`), deepEquals);
  const seperationSieveSize = useSelector(createWorksheetSelector!(`SeparationSieveSize`), deepEquals);
  const guardSieves = useSelector(createWorksheetSelector!(`GuardSieves`), deepEquals) as any[];

  const GuardSievesVisibility =
    PreparationMethodValue === PreparationMethod.Wet ||
    (oversizeMaterialRemovedBy === OversizeMaterialRemovedBy.Mortar_Pestle &&
      PreparationMethodValue !== PreparationMethod.Natural);

  return (
    <>
      <ListFieldSection>
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="OversizeSieve"
          queryParams={{ SieveSize: `${oversizeSieveSize?.Size.value} ${oversizeSieveSize?.Size.uom}` }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="WashingSieve"
          visible={PreparationMethodValue === PreparationMethod.Wet}
          queryParams={{ SieveSize: `${oversizeSieveSize?.Size.value} ${oversizeSieveSize?.Size.uom}` }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="SeparationSieve"
          queryParams={{ SieveSize: `${seperationSieveSize?.Size.value} ${seperationSieveSize?.Size.uom}` }}
          visible={
            oversizeMaterialRemovedBy === OversizeMaterialRemovedBy.Mechanical &&
            PreparationMethodValue !== PreparationMethod.Natural
          }
        />
        {guardSieves?.map((_, index) => (
          <Field
            key={`guardSieve${index}`}
            input={<WorksheetEquipmentDropdown />}
            equipmentType="sieve"
            label={`Guard Sieve ${index + 1}`}
            name={`GuardSieves[${index}].Sieve`}
            queryParams={{ 'SieveSize>': `${guardSieveSize?.Size.value} ${guardSieveSize?.Size.uom}` }}
            visible={GuardSievesVisibility}
          />
        ))}
      </ListFieldSection>
      <FieldSet visible={GuardSievesVisibility}>
        <ButtonGroup>
          <Button
            onClick={() =>
              addArrayEntry!({
                name: prefixName!(`GuardSieves`),
                index: guardSieves.length,
                data: {},
                sync: true,
              })
            }
          >
            Add Guard Sieve
          </Button>
          {guardSieves.length > 1 && (
            <ConfirmDialog
              confirm={() => !isNil(guardSieves[guardSieves.length - 1].Sieve)}
              confirmText="This action will delete the last selected guard sieve and cannot be undone. Continue?"
              confirmButtonText="Remove Guard Sieve"
              confirmTitle="Remove Guard Sieve"
            >
              <Button
                error
                onClick={() =>
                  removeArrayEntry!({
                    name: prefixName!(`GuardSieves`),
                    index: guardSieves.length - 1,
                    data: {},
                    sync: true,
                  })
                }
              >
                Remove Guard Sieve
              </Button>
            </ConfirmDialog>
          )}
        </ButtonGroup>
      </FieldSet>
    </>
  );
};

AsPreparationSieveSection = withInjectedProps(AsPreparationSieveSection);

export { AsPreparationSieveSection };
export default AsPreparationSieveSection;
